/**
 * API wrapper for sessions management
 */

import { apiUrl } from '../config/api';
import { apiFetch } from './client';

const API_BASE = apiUrl('/api/admin/sessions');
const LIST_API_BASE = apiUrl('/api/plans/sessions');

export async function getSessions(onlyActive = false) {
  const url = onlyActive ? `${LIST_API_BASE}?only_active=true` : LIST_API_BASE;
  const response = await apiFetch(url, { auth: true });
  
  if (!response.ok) {
    throw new Error('Erreur lors du chargement des sessions');
  }
  
  const data = await response.json();
  return data.sessions || [];
}

export async function getSessionById(sessionId) {
  const response = await apiFetch(`${API_BASE}/${sessionId}`, { auth: true });
  
  if (!response.ok) {
    throw new Error('Erreur lors du chargement de la session');
  }
  
  return response.json();
}

export async function createSession(session) {
  const response = await apiFetch(API_BASE, {
    method: 'POST',
    auth: true,
    json: true,
    body: JSON.stringify(session)
  });
  
  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.detail || 'Erreur lors de la création de la session');
  }
  
  return response.json();
}

export async function updateSession(sessionId, updates) {
  const response = await apiFetch(`${API_BASE}/${sessionId}`, {
    method: 'PUT',
    auth: true,
    json: true,
    body: JSON.stringify(updates)
  });
  
  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.detail || 'Erreur lors de la mise à jour de la session');
  }
  
  return response.json();
}

export async function deleteSession(sessionId) {
  const response = await apiFetch(`${API_BASE}/${sessionId}`, {
    method: 'DELETE',
    auth: true,
  });
  
  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.detail || 'Erreur lors de la suppression de la session');
  }
  
  return response.json();
}
